export default __webpack_public_path__ + "static/media/Inkedpant_LI.bea9e6a8.jpg";